export const frontStyleOnstreetCommonSelector = ({frontStyleOnstreetCommon}) => frontStyleOnstreetCommon